import React, { useState } from "react";
import CustomIconButton from "../CustomIconButton/CustomIconButton";
// import CustomInputAdornment from "../CustomInputAdornment/CustomInputAdornment";
// import CustomTextField from "../CustomTextField/CustomTextField";
// import { useAsyncDebounce } from "react-table";
import {
    // CustomDeleteOutlineIcon,
    // CustomEditIcon,
    // CustomFavoriteBorderIcon,
    // CustomFavoriteIcon,
    CustomMoreVertIcon,
} from "../CustomIcon/CustomIcon";
import { useStyles } from "../../../assets/jss/PraisoTable";
import CustomPopover from "../CustomPopover/CustomPopover";
import CustomList from "../CustomList/CustomList";
import CustomListItem from "../CustomListItem/CustomListItem";
import CustomListItemText from "../CustomListItemText/CustomListItemText";
import CustomListItemIcon from "../CustomListItemIcon/CustomListItemIcon";
// import CustomFileCopyOutlinedIcon from "../CustomFileCopyOutlinedIcon/CustomFileCopyOutlinedIcon";
// import CustomAddOutlinedIcon from "../CustomAddOutlinedIcon/CustomAddOutlinedIcon";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";
import { updateView } from "../../../services/PraisoTableService";
import { useParams } from 'react-router-dom';
import editIcon from "../../../assets/images/editIcon.png";
import trashIcon from "../../../assets/images/trashIcon.png";
import createIcon from "../../../assets/images/createIcon.png";
import copyIcon from "../../../assets/images/copyIcon.png";
import DeleteViewDialog from "../../Dialogs/ConfirmAction/DeleteView";

export const PraisoTableTitleAction = (props:any) => {
    const { t } = useTranslation();
    const history = useHistory();
    const params = useParams();
    const classes = useStyles();
    const [anchorEl, setAnchorEl] = useState(null);
    const [dialogOpen, setDialogOpen] = useState(false);
    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const handleEditView = () => {
        history.push(`/customtable/${props.tcCode}/edit/${props.viewId}`);
    }

    async function deleteTableComponent() {
        const request = {
            recordStatus: 0, // 0 for delete view
            //tcCode: props.tcCode
        }
        const data = await updateView(request, props.viewId, params);
        props.handleRefreshComponent(data);
    }

    const handleDeleteView = () => {
        setAnchorEl(null);
        setDialogOpen(true);
        // deleteTableComponent();
    }

    // async function copyTableComponentView() {
    //     const data = await copyView(props.viewId, params);
    //     props.handleRefreshComponent(data, true);
    // }

    const handleCopyView = () => {
        // setAnchorEl(null);
        // copyTableComponentView();
        if (props.view.isSystemDefault) {
            history.push(`/customtable/${props.tcCode}/create`);
        } else {
            history.push(`/customtable/${props.tcCode}/copy/${props.viewId}`);
        }
    }

    const deleteDialogFunc = (isOpen, confirmDelete) => {
        setDialogOpen(isOpen);
        if (confirmDelete) {
            deleteTableComponent();
        }
    };

    const handleCreateView = () => {
        //handleCreateView
        history.push(`/customtable/${props.tcCode}/create`);
    }

    const [origin, setOrigin] = useState<any>({
        anchorOrigin: {
            vertical: 10,
            horizontal: "right",
        },
        transformOrigin: {
            vertical: 10,
            horizontal: "left",
        },
    });

    const divRef = React.useRef();
    const open = Boolean(anchorEl);
    const id = open ? "praisoTitleActionPopover" : undefined;
    return (
        <div ref={divRef}>
            <CustomIconButton style={{ margin: '10px' }} aria-describedby={id} onClick={handleClick}>
                <CustomMoreVertIcon />
            </CustomIconButton>
            <CustomPopover className={classes.titleActionContainer}
                id={id}
                open={open}
                anchorEl={anchorEl}
                onClose={handleClose}
                anchorOrigin={origin.anchorOrigin as Number}
                transformOrigin={origin.transformOrigin as Number}
            >
                <CustomList dense={true} className={classes.titleActionList}>
                    <CustomListItem className={classes.titleActionListItem} onClick={() => handleCopyView()}>
                        <CustomListItemIcon className={classes.titleActionListItemIcon}>
                            {/* <CustomFileCopyOutlinedIcon /> */}
                            <img src={copyIcon} />
                        </CustomListItemIcon>
                        <CustomListItemText
                            className={classes.titleActionListItemText}
                            primary={t("Copy")}
                        ></CustomListItemText>
                    </CustomListItem>
                    <CustomListItem className={classes.titleActionListItem} disabled={props.view.isSystemDefault} onClick={() => !props.view.isSystemDefault ? handleEditView() : null}>
                        <CustomListItemIcon className={classes.titleActionListItemIcon}>
                            {/* <CustomEditIcon /> */}
                            <img src={editIcon} />
                        </CustomListItemIcon>
                        <CustomListItemText
                            className={classes.titleActionListItemText}
                            primary={t("EDIT")}
                        ></CustomListItemText>
                    </CustomListItem>
                    <CustomListItem className={classes.titleActionListItem} disabled={props.view.isSystemDefault} onClick={() => !props.view.isSystemDefault ? handleDeleteView() : null}>
                        <CustomListItemIcon className={classes.titleActionListItemIcon}>
                            {/* <CustomDeleteOutlineIcon /> */}
                            <img src={trashIcon} />
                        </CustomListItemIcon>
                        <CustomListItemText
                            className={classes.titleActionListItemText}
                            primary={t("DELETE")}
                        ></CustomListItemText>
                    </CustomListItem>
                    <CustomListItem className={classes.titleActionListItem} onClick={() => handleCreateView()}>
                        <CustomListItemIcon className={classes.titleActionListItemIcon}>
                            {/* <CustomAddOutlinedIcon /> */}
                            <img src={createIcon} />
                        </CustomListItemIcon>
                        <CustomListItemText
                            className={classes.titleActionListItemText}
                            primary={t("CREATE_NEW_VIEW")}
                        ></CustomListItemText>
                    </CustomListItem>
                </CustomList>
            </CustomPopover>
            <DeleteViewDialog
                dialogOpen={dialogOpen}
                dialogClose={(isOpen, confirmDelete) =>
                    deleteDialogFunc(isOpen, confirmDelete)
                }
                viewName={props.view.tableName}
            />
        </div>
    );
};
